<template>
  <div style="max-width: 960px;">
    <DraggableInputContent namespace="directorySettings" name="Category" />
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import DraggableInputContent from '@/components/DesignSystem/DraggableInput/DraggableInputContent';
const { mapActions } = createNamespacedHelpers('directorySettings');

export default {
  components: {
    DraggableInputContent,
  },
  methods: {
    ...mapActions(['fetchDirectoryCategories', 'clearItems']),
  },
  created() {
    this.clearItems();
    //this.fetchDirectoryCategories();
  },
};
</script>
